import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { createAddDocApplicantDetailsValidationSchema } from "../../../../../../yup/common/applicant/applicantDetailsValidationSchema";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepApplicant from "../../../../../../hooks/useStepApplicant";
import { initialAdditionalDocApplicantDetails } from "../../../../../../init/common/applicantDetailsInitialValues";
import {
  setStepApplicantEdited,
  setRequestIdentifier,
  completeApplicantStep,
} from "../../../../../../store/redux/slice/Forms/regprofAdditionalDocForm";
import AdditionalDocApplicantDetailsForm from "../../../common/form/applicant/AdditionalDocApplicantDetailsForm";

const RegprofAdditionalDocStepApplicant = () => {
  const regprofAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.RegprofAdditionalDocForm;
  });

  const { methods, onSubmit } = useStepApplicant(
    regprofAdditionalDocForm,
    baseEndpointPaths.regprofAdditionalDoc,
    createAddDocApplicantDetailsValidationSchema,
    setStepApplicantEdited,
    setRequestIdentifier,
    completeApplicantStep,
    initialAdditionalDocApplicantDetails,
    false,
    false,
    true,
  );

  useFormReset("REGPROF_ADDITIONAL_DOCUMENTS", regprofAdditionalDocForm.applicantDetails, methods.reset);

  return <AdditionalDocApplicantDetailsForm methods={methods} onSubmit={onSubmit} hasRepresentativeCompany={true} />;
};
export default RegprofAdditionalDocStepApplicant;
